import { render, staticRenderFns } from "./DuplicateStep3Finish.vue?vue&type=template&id=106d65a4&scoped=true&"
import script from "./DuplicateStep3Finish.vue?vue&type=script&lang=js&"
export * from "./DuplicateStep3Finish.vue?vue&type=script&lang=js&"
import style0 from "./DuplicateStep3Finish.vue?vue&type=style&index=0&id=106d65a4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "106d65a4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/www/uat.workflow.dashtogo.com/laravel/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('106d65a4')) {
      api.createRecord('106d65a4', component.options)
    } else {
      api.reload('106d65a4', component.options)
    }
    module.hot.accept("./DuplicateStep3Finish.vue?vue&type=template&id=106d65a4&scoped=true&", function () {
      api.rerender('106d65a4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/csmworkflow/js/components/duplication/DuplicateStep3Finish.vue"
export default component.exports